module.exports = __webpack_public_path__ + "static/media/planos_vita.7e38ecdd.png";